export const createFormdataValues = (values) => {
    const form_data = new FormData();
    for (const key in values) {
        if (Object.hasOwnProperty.call(values, key)) {
            if (values[key])
                form_data.append(key, values[key])
        }
    };
    return form_data
}